import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["id", "required"]
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "block mb-1.5 text-xs font-semibold text-gray-600" }
const _hoisted_4 = ["for"]
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col items-center gap-1.5 pointer-events-none\"><svg class=\"w-7 h-7 text-gray-300 group-hover:text-[#6CC551] transition-colors\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12\"></path></svg><p class=\"text-xs font-semibold text-gray-400 group-hover:text-[#6CC551] transition-colors\">Click to upload</p><p class=\"text-[10px] text-gray-400\">Any supported file format</p></div>", 1)
const _hoisted_6 = ["id", "required"]
const _hoisted_7 = ["for"]
const _hoisted_8 = {
  key: 0,
  class: "text-red-400 ml-0.5"
}
const _hoisted_9 = ["type", "id", "placeholder", "required", "value"]


const __default__ = {
  inheritAttrs: false
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'InputField',
  props: {
    label: null,
    id: null,
    type: null,
    placeholder: null,
    isRequired: { type: Boolean },
    modelValue: null,
    className: null
  },
  emits: ['update:modelValue'],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.type === 'checkbox')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["flex items-start gap-3", __props.className])
        }, [
          _createElementVNode("input", _mergeProps(_ctx.$attrs, {
            id: __props.id,
            type: "checkbox",
            class: "mt-0.5 w-4 h-4 rounded border-gray-300 cursor-pointer accent-[#6CC551]",
            required: __props.isRequired
          }), null, 16, _hoisted_1),
          _createElementVNode("label", {
            for: __props.id,
            class: "text-xs font-medium text-gray-700 leading-relaxed cursor-pointer"
          }, _toDisplayString(__props.label), 9, _hoisted_2)
        ], 2))
      : (__props.type === 'file')
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["text-left", __props.className])
          }, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(__props.label), 1),
            _createElementVNode("label", {
              for: __props.id,
              class: "flex flex-col items-center justify-center w-full h-28 border-2 border-dashed border-gray-200 rounded-xl cursor-pointer hover:border-[#6CC551]/60 hover:bg-[#6CC551]/5 transition-colors group"
            }, [
              _hoisted_5,
              _createElementVNode("input", _mergeProps(_ctx.$attrs, {
                id: __props.id,
                type: "file",
                class: "hidden",
                required: __props.isRequired
              }), null, 16, _hoisted_6)
            ], 8, _hoisted_4)
          ], 2))
        : (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["text-left", __props.className])
          }, [
            _createElementVNode("label", {
              for: __props.id,
              class: "block mb-1.5 text-xs font-semibold text-gray-600"
            }, [
              _createTextVNode(_toDisplayString(__props.label), 1),
              (__props.isRequired)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "*"))
                : _createCommentVNode("", true)
            ], 8, _hoisted_7),
            _createElementVNode("input", _mergeProps(_ctx.$attrs, {
              type: __props.type,
              id: __props.id,
              class: "w-full px-4 py-2.5 text-sm text-gray-800 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#6CC551]/30 focus:border-[#6CC551] transition-colors placeholder:text-gray-400",
              placeholder: __props.placeholder,
              required: __props.isRequired,
              value: __props.modelValue,
              onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', ($event.target as HTMLInputElement).value)))
            }), null, 16, _hoisted_9)
          ], 2))
  ]))
}
}

})